import Vue from 'vue';
import importWrapper from '@/lib/utils/chunk-import-wrapper';
import Router from 'vue-router';

const LinkComponent = importWrapper(() => {
  return import(
    /* webpackChunkName: "share-home" */ '@/app/pages/player/LinkComponent.vue'
  );
});

const EmbedVideoComponent = importWrapper(() => {
  return import(
    /* webpackChunkName: "embed-video" */ '@/app/pages/EmbedVideoComponent.vue'
  );
});

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/share/:linkId/embed',
      component: EmbedVideoComponent,
      name: 'embed_video',
      meta: {
        headless: true
      }
    },
    {
      path: '/share/:linkId',
      component: LinkComponent,
      name: 'share'
    },
    { path: '*', redirect: '/share' }
  ]
});

export default router;
